<template>
	<DialogPanel class="lite-dialog-panel"
		:scroll-body="false"
		@close="$emit( `close` )"
	>
		<template #body="{ onClose }">
			<header class="header">
				<h1><slot name="title"></slot></h1>
				<CloseButton
					size="SMALL"
					type="TERTIARY"
					@click="onClose"
				/>
			</header>
			<div class="sub-body">
				<slot name="body" :onClose="onClose"></slot>
			</div>
			<footer class="footer">
				<slot name="footer" :onClose="onClose"></slot>
			</footer>
		</template>
	</DialogPanel>
</template>

<script>
import CloseButton from "../buttons/CloseButton.vue";
import DialogPanel from "./DialogPanel.vue";

/**
 * Non-scrollable panel container for use with SparseDialog.
 * @code
 * <SparseDialog>
 *     <LiteDialogPanel>
 *         <template #title></template>
 *         <template #body></template>
 *         <template #footer></template>
 *     </LiteDialogPanel>
 * </SparseDialog>
 */
export default {
	name: "LiteDialogPanel",
	teamingPackage: "common-ui",
	components: {
		CloseButton,
		DialogPanel,
	},
};
</script>

<style lang="scss" scoped>
$headingColor: $color1-700;
// Setting outer gutter on individual sections so that
// we can control the appearance of the sub-body scroll
// bar. Setting padding on sub-body pushes the scroll
// bar to the edge of the panel. Margin is used for
// header/footer.
$outerGutterSize: 1.5rem;

.lite-dialog-panel .sub-body {
	flex: 1;

	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: 1rem;

	padding: 0 $outerGutterSize;
	@include auto-y-scroll();
}

.lite-dialog-panel .header {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;

	h1 {
		@include font-and-line-for(2);
		color: $headingColor;
	}

	// no bottom margin
	margin: $outerGutterSize $outerGutterSize 0 $outerGutterSize;
}

.lite-dialog-panel .footer {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	gap: 0.5rem;

	// no top margin
	margin: 0 $outerGutterSize $outerGutterSize $outerGutterSize;
}
</style>

<style lang="scss">
.lite-dialog-panel.dialog-panel .body {
	display: flex;
	flex-direction: column;
	gap: 2rem;
}
</style>
